import { IDbBaseMetadataValueInfos, BaseMetadataValueInfosCache } from "./i-db-base-metadata-value-infos";

export class MetadataFieldValueInfosCache {
  id: number | null = 0;
  eid: number | null = 0;
  lb: string | null = null;
  vo: BaseMetadataValueInfosCache | null = null;
  v: string | null = "";

  constructor(init?: Partial<MetadataFieldValueInfosCache>) {
    Object.assign(this, init);
  }
}

export class DbMetadataFieldValueInfos {
  id: number | null = 0;
  externalId: number | null = 0;
  externalValue: string | null = null;
  label: string | null = null;
  rfc5646: string | null = null;
  valueObject: IDbBaseMetadataValueInfos | null = null;
  value: string | null = "";

  constructor(init?: Partial<DbMetadataFieldValueInfos>) {
    Object.assign(this, init);
  }
}
